import { NOT_APPLICABLE } from '../SearchContentTable.constants';
import { ColumnHelperMethodType } from '../SearchContentTable.types';
import { getEngagements } from '../SearchContentTable.utils';
import { TextCell } from '../components/TextCell';

export const ColumnEngagements: ColumnHelperMethodType = (columnHelper) =>
  columnHelper.accessor((row) => row.contentId, {
    id: 'engagements',
    cell: ({ row }) => {
      const engagements = getEngagements(row.original);
      return <TextCell>{engagements ?? NOT_APPLICABLE}</TextCell>;
    },
  });
